import styled from 'styled-components';

import { ASIDE_WIDTH } from '@/core/components/Layout/Layout.styles';

import { getVariant } from '@/themes/typographyUtilis';

const CONTENT_MAX_WIDTH = 850;

export const PageWrapper = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
  min-height: 100%;
  padding: 0 24px 24px;
  background: ${({ theme }) => theme.colors.background.dark};
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ActionButton = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border: 1px solid transparent;
  border-radius: 6px;
  padding: 6px 10px;
  background: transparent;
  color: ${({ theme }) => theme.colors.warning};
  cursor: pointer;

  &:hover {
    opacity: 0.85;
  }
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const MetadataToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const MetadataGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
`;

export const MetadataField = styled.div<{ $span?: number }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  grid-column: span ${({ $span }) => $span ?? 1};
`;

export const Label = styled.span`
  color: ${({ theme }) => theme.colors.secondaryText};
  ${getVariant({ variant: 'body1-normal' })}
`;

export const TitleInput = styled.input`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.background.medium};
  border-radius: 6px;
  padding: 10px 12px;
  background: ${({ theme }) => theme.colors.background.light};
  color: ${({ theme }) => theme.colors.primaryText};
  ${getVariant({ variant: 'body1-normal' })}
  text-align: left;

  &::placeholder {
    opacity: 0.85;
    color: ${({ theme }) => theme.colors.secondaryText};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.active};
  }
`;

export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ModalContent = styled.div`
  width: calc(100vw - ${ASIDE_WIDTH});
  height: 100%;
  min-height: 100%;
  background-color: ${({ theme }) => theme.colors.background.dark};
`;

export const ContentInner = styled.div`
  width: 100%;
  max-width: ${CONTENT_MAX_WIDTH}px;
  height: 100%;
  min-height: 100%;
  margin: 0 auto;
`;
